import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { useCart } from "@/context/CartContext";

export function ProductCard({ product, index = 0 }) {
  const { addItem } = useCart();
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.4, delay: (index % 4) * 0.08 }}
      className="group bg-white rounded-3xl border border-slate-100 shadow-sm hover:shadow-xl hover:shadow-amber-500/10 hover:-translate-y-1 transition-[transform,box-shadow] duration-300 overflow-hidden flex flex-col"
      data-testid={`product-card-${product.id}`}
    >
      <div className="relative h-52 overflow-hidden bg-slate-50">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-3 left-3 px-3 py-1 rounded-full text-xs font-bold bg-white/90 text-slate-700">
          {product.category}
        </span>
      </div>
      <div className="p-6 flex flex-col flex-1">
        <h3 className="font-heading font-extrabold text-lg text-slate-900 mb-1">{product.name}</h3>
        <p className="text-sm text-slate-500 line-clamp-2 mb-4 flex-1">{product.description}</p>
        <div className="flex items-center justify-between mt-auto">
          <span className="font-heading font-extrabold text-2xl text-slate-900">
            {product.price.toFixed(2)} €
          </span>
          <button
            data-testid={`add-to-cart-${product.id}`}
            onClick={() => {
              addItem(product);
              toast.success(`${product.name} ajouté au panier`);
            }}
            className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full bg-slate-900 text-white text-sm font-bold hover:bg-sky-600 hover:scale-105 transition-[transform,background-color]"
          >
            <Plus className="w-4 h-4" /> Ajouter
          </button>
        </div>
      </div>
    </motion.div>
  );
}
